import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  change(event) {
    const url = event.target.value;

    if (url) {
      Turbo.visit(url);
    }
  }
}
